export enum ContractType {
    Day = 1,
    Evening = 2,
    Night = 3,
    Rotate = 4
}

export enum ContractStatus {
    PRE = 'Pre-Start',
    PER_DIEM = 'Per Diem Pre-Start'
}

export enum ContractSchedule {
    Standard = 1,
    Rotating = 2,
    Alternating = 3,
}
